import {
  createClient,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { Tariff } from './model';

const client = createClient('/rest/tariffs');

export const tariffsPermissions = {
  SEARCH: 'cpms.search-tariffs',
  GET: 'cpms.get-tariff',
  GET_CURRENCIES: 'cpms.get-all-tariff-currencies',
  CREATE: 'cpms.create-tariff',
  RESEND: 'cpms.resend-tariffs',
  ADD_OCPI_LOCATIONS: 'cpms.add-tariff-locations',
  REMOVE_OCPI_LOCATIONS: 'cpms.remove-tariff-locations'
};

export const searchTariffs: SearchOperation<Tariff> = searchRequestFactory<Tariff>(client, {
  permissionId: tariffsPermissions.SEARCH
});

export const createTariff: SaveOperation<Tariff> = postRequestFactory<Tariff>(client, {
  pattern: '',
  permissionId: tariffsPermissions.CREATE
});

export const getCurrencies: FindOperation<string[]> = getRequestFactory<string[]>(client, {
  pattern: '/currencies',
  permissionId: tariffsPermissions.GET_CURRENCIES
});

export const getTariff: FindOperation<Tariff, string> = getRequestFactory<Tariff, string>(client, {
  permissionId: tariffsPermissions.GET
});

export interface ResendTariffsCommand {
  tariffIds: string[];
}

export const resendTariffs: SaveOperation<ResendTariffsCommand, never> = postRequestFactory<
  ResendTariffsCommand,
  never
>(client, {
  pattern: '/resend',
  permissionId: tariffsPermissions.RESEND
});

export interface AddOcpiLocationsCommand {
  replace: boolean;
  locationIds: string[];
}

export const addOcpiLocationsToTariff: SaveOperation<AddOcpiLocationsCommand, void, string> = postRequestFactory<
  AddOcpiLocationsCommand,
  void,
  string
>(client, { pattern: '/{tariffId}/add-locations', permissionId: tariffsPermissions.ADD_OCPI_LOCATIONS });

export interface RemoveOcpiLocationsCommand {
  locationIds: string[];
}

export const removeOcpiLocationsFromTariff: SaveOperation<RemoveOcpiLocationsCommand, void, string> =
  postRequestFactory<RemoveOcpiLocationsCommand, void, string>(client, {
    pattern: '/{tariffId}/remove-locations',
    permissionId: tariffsPermissions.REMOVE_OCPI_LOCATIONS
  });
